export function showCategorySearchHeader() {
  return true
}
